import React from 'react';
import CaseStudySquareCards from './CaseStudySquareCards';

const CaseStudySquareCardsWithProps = (props: any) => {
  return (
    <CaseStudySquareCards
      title={props.title}
      description={props.description}
      ctaLabel={props.ctaLabel}
      ctaLink={props.ctaLink}
      caseStudies={props.caseStudies}
    />
  );
};

export default CaseStudySquareCardsWithProps;
